import { lazy } from 'react';
// 频道列表页配置
const ChannelManager = lazy(() => import('pages/channelManager'));

const router = {
    path: '/channel',
    name: '频道管理',
    icon: 'global',
    permission: 109,
    children: [
        {
            path: 'manager',
            name: '频道配置',
            icon: 'global',
            permission: 10901,
            component: ChannelManager,
        },
    ],
};

// 频道管理模块路由
export default router;
